import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord, faTwitter } from '@fortawesome/free-brands-svg-icons';

const HeaderContainer = styled.div`
  grid-area: 1 / 1 / 2 / 7;
  background: var(--header-bg);
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--border-dark);
  padding: 0 20px;
  z-index: 100;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;

  a {
    color: var(--border-light);
    font-size: 14px;
    transition: color 0.2s;

    &:hover {
      color: #6a75a8;
    }
  }
`;

const Header = () => {
  return (
    <HeaderContainer>
      <SocialIcons>
        <a href="#"><FontAwesomeIcon icon={faDiscord} /></a>
        <a href="#"><FontAwesomeIcon icon={faTwitter} /></a>
      </SocialIcons>
    </HeaderContainer>
  );
};

export default Header; 